module.exports = __webpack_public_path__ + "img/lqdefault.1f740a94.jpg";